import styled from 'styled-components';

export const HeaderWrapper = styled.div`
.site-header {
    z-index: 99;
    position: relative;
}
.header-bar{
    border-bottom-width: 1px;
    border-bottom-color: #647f19;
    border-bottom-style: solid;
    background-image: linear-gradient(135deg, #e7faca 0%, #485c00 100%);
}
.site-header-section {
    height: 100%;
    min-height: 0;
    align-items: center;
}
.site-title {
    font-size: 26px;
    font-size: 1.625rem;
    display: block;
    font-weight: 600;
    justify-self: flex-start;
    margin-top: 5vh;
    margin-inline:auto;
}
.site-description{
    justify-self: flex-start;
    color: #111111;
    margin-inline:auto;
    font-weight: 400;
}
.site-header .site-description {
    font-size: 15px;
    font-size: .9375rem;
    display: block;
}
.search-form{
    justify-content: flex-end;
    margin-right: -4vw;
    margin-top: 12vh;
}
.header-logo{
    margin-top: 3vh;
}
.site-title a{
    color: #111111;
    text-decoration: none;
}
.button a{
    text-decoration: none;
    color: rgb(191, 219, 32);
}
.header-nav{
    min-height: 80px;
    align-content: center;
    border-style: solid;
    border-width: 0;
    border-bottom-width: 5px;
    border-bottom-color: #647f19;
}
.container-fluid{
    overflow: visible;
}
.dropdown-menu{
    margin-top: 7vh;
}
/* Media query for mobile devices (screen width 768px and below) */
	@media screen and (max-width: 768px) {
	  .navbar-nav{
        flex-direction: column !important;
	  }
      .nav-item{
        text-align: end;
        margin-right: 5vw;
      }
	}
`;
